import { render, staticRenderFns } from "./WhatsappV2BotStateChanged.vue?vue&type=template&id=502dc310&scoped=true"
import script from "./WhatsappV2BotStateChanged.vue?vue&type=script&lang=js"
export * from "./WhatsappV2BotStateChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502dc310",
  null
  
)

export default component.exports